import { render, staticRenderFns } from "./UiButtons.vue?vue&type=template&id=22c2d9fc&"
import script from "./UiButtons.vue?vue&type=script&lang=js&"
export * from "./UiButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports